"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));
var CardMedia = function (_a) {
    var classes = _a.classes, children = _a.children, component = _a.component, image = _a.image, src = _a.src;
    return (react_1.default.createElement(CardMedia_1.default, { classes: classes, component: component, image: image, src: src }, children));
};
exports.default = CardMedia;
